export const Loader = () => {
    return `<div class="loader">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>`;
}

export const LoaderThankYou = (message = 'A fulfillment expert will get back to you shortly.') => {
    return `<div class="loader">
            <h6 class='loader-title'>Thank You!</h6>
            <p>${ message }</p>
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>`;
}